angular.module("app").controller("FilterPageController", [
    '$scope',
    '$location',
    'preloadedData',
    'pageStatuses',
    'pagination',
    '$timeout',
    'casinoCategoryService',
    'iconsService',
    'errorHandler',
    '$state',
    '$stateParams',
    'settingsService',
    '$uibModal',
    'toolsMap',
    'logger',
    'userStorage',
    function ($scope, $location, preloadedData, pageStatuses, pagination, $timeout, casinoCategoryService, iconsService, errorHandler, $state, $stateParams, settingsService, $modal, toolsMap, logger, userStorage) {
        var pendingListRequest;
        $scope.pageStatuses = pageStatuses;
        $scope.isCustomOptions = ['-1','0','1'];
        $scope.categories = angular.copy(preloadedData.categories);
        $scope.filterOptions = {
            status: pageStatuses[0],
            is_custom: '-1'
        };
        var typeOfPaths = {
            "/features/list": "feature",
            "/categories/list": "category",
            "/themes/list": "theme"
        };
        var typePermissions = {
            "feature": "manageGameFeatures",
            "category": "manageGameCategories",
            "theme": "manageGameThemes"
        };
        var type = typeOfPaths[$location.path()];
        $scope.permission = typePermissions[type];
        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData =  getFiltersValues();
                resetPage === true && (requestData.current_page = 1);
                updateList(requestData)
            }, 300);
        }, parseInt(preloadedData.total_count), 25);

        $scope.add = function () {
            $modal.open({
                templateUrl: "views/filters/add.html",
                controller: "FiltersAddPageController",
                resolve: {
                    type: function () {
                        return type;
                    },
                    preloadedSkins: function (casinoGameService, errorHandler) {
                        return casinoGameService.getSkins().then(
                            function (response) {
                                if (response.status == "ok") {
                                    return angular.copy(response.skins).map(function (item) {
                                        item.name = "ID:" + item.id + " " + item.name;
                                        return item
                                    });
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                }
            }).result.then(function () {
                var requestData =  getFiltersValues();
                updateList(requestData)
            });
        };

        $scope.changeCategoryStatus = function (item) {
            var modalInstance = $modal.open({
                templateUrl: item.status === 'archive' ? "views/templates/modals/confirmPublishAction.html" : "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function () {
                casinoCategoryService.changeStatusCategoryById({id: item.id, status: item.status}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess(item.status === 'archive' ? "Category has been successfully publish" : "Category has been successfully deleted");
                            updateList(getFiltersValues())
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            })
        };


        $scope.edit = function (category) {
            $modal.open({
                templateUrl: "views/filters/edit.html",
                controller: "FiltersEditPageController",
                resolve: {
                    preloadedData: function (casinoCategoryService, errorHandler) {
                        return casinoCategoryService.getCategories({id: category.id}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    type: function () {
                        return type;
                    }
                }
            }).result.then(function () {
                var requestData =  getFiltersValues();
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                updateList(requestData)
            });
        };

        var iconsCategory = [4] // casino

        $scope.addIcon = function (category) {
            $modal.open({
                templateUrl: "views/filters/addIcon.html",
                controller: "FiltersAddIconPageController",
                resolve: {
                    preloadedIcons: function (iconsService, errorHandler) {
                        return iconsService.getIconsList(iconsCategory).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    type: function () {
                        return type;
                    },
                    iconsCategory: function () {
                        return iconsCategory
                    },
                    selectedIcon: function () {
                        return {icon :category.icon, icon_src: category.icon_src};
                    }
                },
            }).result.then(function (icon) {
                var requestData = getFiltersValues();
                $scope.parentId && (requestData.parent_id = $scope.parentId);
                casinoCategoryService.setIcon({id: category.id, icon: icon.name}).then(function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess('global.successfullyUpdated');
                            category.icon = icon.name;
                            category.icon_src = icon.src;
                            updateList(requestData)
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    });
            });
        };

        $scope.inactiveToggle = function (page, action, title) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function () {
                casinoCategoryService.toggleItemInactive(page.id, title).then(
                    function (response) {
                        if (response.status === "ok") {
                            updateList(getFiltersValues())
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )
            })
        };

        $scope.ignoreColumns = {
            'parent_id': true,
            'author': true,
            'status': true,
            '$$hashKey': true,
            'show_subcategories': true,
            'order': true,
            'created_at': true,
            'type': true,
            'icon': true,
            'is_custom': true
        };
        if (userStorage.getUserData().permissions.indexOf($scope.permission) !== -1) {
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.edit(item);
                    },
                    title: function () {
                        return $scope.filterOptions.status ?  toolsMap[$scope.filterOptions.status].editToggle.title : 'edit';
                    }
                },
                inactiveToggle: {
                    action: function (item) {
                        $scope.inactiveToggle(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },

                addIcon: {
                    action: function (item) {
                        $scope.addIcon(item)
                    },
                    class: function () {
                        return "plus";
                    },
                    title: function () {
                        return "Add Icon";
                    }
                },

                publishToggle: {
                    action: function (item) {
                        $scope.changeCategoryStatus(item)
                    },
                    class: function () {
                        return $scope.filterOptions.status;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };

            if (type !== "category") {
                delete $scope.tools.addIcon;
            }
        }


        function getFiltersValues() {
            var filters = {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                search: $scope.filterOptions.search,
                type: type
            }

            var isCustom = $scope.filterOptions.is_custom;

            if (isCustom != '-1') {
                filters.is_custom = isCustom;
            }

            return filters
        }

        function updateList (requestOptions) {
            settingsService.setFilters(requestOptions);
            casinoCategoryService.getCategories(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.categories = angular.copy(response.categories);
                        $scope.pagination.totalItems = response.total_count
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        $scope.listFilterObject = {
            action: function () {
                var requestData =  getFiltersValues();
                updateList(requestData)
            }
        }
    }
]);
